export enum FeaturePermission {
  TICKET = 'TICKET',
  CREDIT_CARD = 'CREDIT_CARD',
  REPORT = 'REPORT',
  CONTROL_PANEL = 'CONTROL_PANEL',
  STAFF = 'STAFF',
  CUSTOMER = 'CUSTOMER',
  GIFT_CARD = 'GIFT_CARD',
  EDIT_TICKET = 'EDIT_TICKET',
  VOID_TICKET = 'VOID_TICKET',
  REFUND_TICKET = 'REFUND_TICKET',
  DELETE_TICKET = 'DELETE_TICKET',
}
